import { type Language } from '@/utils/languageUtils';
import svLocale from '../locales/sv/dealerPortal.json';
import enLocale from '../locales/en/dealerPortal.json';
import type { DealerPortalVehicleStatus } from '@/types/dealerPortal';

const getDealerPortalLocale = (lang?: Language) => {
  const effectiveLang = lang === 'en' ? 'en' : 'sv';
  switch (effectiveLang) {
    case 'en':
      return enLocale as typeof svLocale;
    case 'sv':
    default:
      return svLocale;
  }
};

export const dealerPortalLabels = (lang?: Language) => {
  return getDealerPortalLocale(lang);
};

export type DealerPortalStatusKey = 'FIRST_CONTACT' | 'PRODUCT_VIEWING' | 'NEGOTIATION' | 'CLOSED' | 'NOT_COMPLETED';
export type DealerPortalPriorityKey = 'LOW' | 'MEDIUM' | 'HIGH';

export const getJourneyStatusLabels = (lang?: Language): Record<DealerPortalStatusKey, string> => {
  const d = dealerPortalLabels(lang).journey;
  return {
    FIRST_CONTACT: d.statusFirstContact,
    PRODUCT_VIEWING: d.statusProductViewing,
    NEGOTIATION: d.statusNegotiation,
    CLOSED: d.statusClosed,
    NOT_COMPLETED: d.statusNotCompleted,
  };
};

export const getJourneyPriorityLabels = (lang?: Language): Record<DealerPortalPriorityKey, string> => {
  const d = dealerPortalLabels(lang).journey;
  return {
    LOW: d.priorityLow,
    MEDIUM: d.priorityMedium,
    HIGH: d.priorityHigh,
  };
};

export const getDealerPortalVehicleStatusLabels = (lang?: Language): Record<DealerPortalVehicleStatus, string> => {
  const v = (dealerPortalLabels(lang).vehicles ?? {}) as Record<string, string>;
  return {
    TEST: v.statusTest ?? 'Test',
    TRADE_IN: v.statusTradeIn ?? 'Inbyte',
    INBOUND: v.statusInbound ?? 'Inleverans',
    PICKED_UP: v.statusPickedUp ?? 'Hämtad',
    DELIVERED: v.statusDelivered ?? 'Levererad',
    SOLD: v.statusSold ?? 'Såld',
    IN_STOCK: v.statusInStock ?? 'Lager',
  };
};
